import classNames from 'classnames';
import omit from 'omit.js';
import React, { useState, useCallback, useMemo } from 'react';
import Button from '../../wui-button/src';
import { WebUI, getNid } from "../../wui-core/src/index";
import { ButtonGroupProps } from "./iButtonGroup";

/* const propTypes = {
    /!**
	 * 是否垂直排列
	 *!/
    vertical: PropTypes.bool,
    /!**
	 * 是否对齐
	 *!/
    justified: PropTypes.bool,

    /!**
	 * 垂直时是否为块状元素
	 *!/
    block: PropTypes.bool,
    /!**
	 * 传入数组替代button
	 *!/
    list: PropTypes.array,
    separated: PropTypes.bool,
    clsPrefix: PropTypes.string
};*/

const defaultProps = {
    block: false,
    justified: false,
    vertical: false,
    list: [],
    clsPrefix: "u-button-group"
};

const ButtonGroupComponent: React.FC<ButtonGroupProps> = (props) => {
    const [activeKey, setActiveKey] = useState('');

    const handleItemClick = useCallback((key?: string, onClick?: (e: React.MouseEvent) => void) => (e: React.MouseEvent) => {
        setActiveKey(key || '');
        onClick && onClick(e);
    }, []);

    const { block, justified, clsPrefix, separated, vertical, className, list, ...others } = props;

    const tbClass = useMemo(() => ({
        [`${clsPrefix}`]: !vertical,
        [`${clsPrefix}-block`]: vertical ? block : false,
        [`${clsPrefix}-vertical`]: vertical,
        [`${clsPrefix}-justified`]: justified,
        [`${clsPrefix}-separated`]: separated
    }), [clsPrefix, vertical, block, justified, separated]);

    if (list!.length === 0) {
        return (
            <div
                {...others}
                className={classNames(tbClass, className)}
            >
                {props.children}
            </div>
        );
    }

    const adapterNid = getNid(props);

    return (
        <div
            {...others}
            className={classNames(tbClass, className)}
            {...adapterNid}
        >
            {list!.map((item, i) => {
                const { title, onClick, className, ...otherProps } = item;
                return (
                    <Button
                        key={item.key || i}
                        className={classNames(className, { 'active': activeKey === item.key })}
                        onClick={handleItemClick(item.key, onClick)}
                        {...omit(otherProps, ["isText"])}
                    >
                        {title}
                    </Button>
                );
            })}
        </div>
    );
};

const ButtonGroup = WebUI({ name: "button-group", defaultProps })(ButtonGroupComponent);

// ButtonGroup.propTypes = propTypes;

export default ButtonGroup;
